const EventsListItemId = () => import(/* webpackChunkName: "misc" */ '@/components/Events/ListItemId')
const ListItemDateTime = () => import('@/components/Engine/ListItemDateTime')
const ListItemActiveDot = () => import('@/components/Engine/ListItemActiveDot')
const EventsListActions = () => import(/* webpackChunkName: "misc" */ '@/components/Events/ListActions')

const eventsModel = vm => ({
  title: vm.$gettext('Events'),
  endpoint: 'events',
  allowNew: true,
  countrize: 'area.country',
  fields: [
    {
      key: 'id',
      sortable: true,
      component: (value, key, item) => ({
        is: EventsListItemId,
        props: { value, item },
        on: {
          refresh: () => vm.$root.$emit('bv::refresh::table', 'apiListTable')
        }
      })
    },
    {
      key: 'area_id',
      label: vm.$gettext('Area'),
      sortable: true,
      editable: true,
      required: true,
      formatter: (value, key, item) => (item.area ? item.area.name : '')
    },
    {
      key: 'event_type_id',
      label: vm.$gettext('Event Type'),
      sortable: true,
      editable: true,
      required: true,
      formatter: (value, key, item) => (item.event_type ? item.event_type.name : '')
    },
    {
      key: 'amount',
      label: vm.$gettext('Amount'),
      sortable: false,
      editable: true,
      required: true,
      formatter: (value, key, item) => value + ' ' + (item.amount_type === 'percentage' ? '%' : item.area.currency)
    },
    {
      key: 'amount_type',
      label: vm.$gettext('Amount Type'),
      sortable: false,
      editable: true,
      required: true
    },
    {
      key: 'from_date',
      label: vm.$gettext('From Date'),
      sortable: true,
      editable: true,
      required: true,
      component: value => ({
        is: ListItemDateTime,
        props: { value }
      })
    },
    {
      key: 'to_date',
      label: vm.$gettext('To Date'),
      sortable: true,
      editable: true,
      required: true,
      component: value => ({
        is: ListItemDateTime,
        props: { value }
      })
    },
    {
      key: 'active',
      label: vm.$gettext('Active'),
      sortable: false,
      editable: true,
      required: true,
      component: value => ({
        is: ListItemActiveDot,
        props: { value }
      })
    },
    {
      key: 'actions',
      label: vm.$gettext('Actions'),
      hidden: true,
      component: (value, key, item, row) => ({
        is: EventsListActions,
        props: { row },
        on: {
          refresh: () => vm.$root.$emit('bv::refresh::table', 'apiListTable')
        }
      })
    }
  ],
  filters: ['id', 'area_id', 'event_type_id', 'amount', 'amount_type', 'from_date', 'to_date', 'active'],
  exclude: ['amount_type'],
  includes: ['area', 'event_type']
})

export default eventsModel
